export default __webpack_public_path__ + "static/media/roboto-latin-500italic.18d00f73.woff";